@if (!hasInitials()) {
  <span
    class="td-wb-avatar__container"
    [style.--td-wb-avatar-size]="getSize()"
    [class.td-wb-avatar__container--outlined]="isOutlined()"
    [class.td-wb-avatar__container--solid]="!isOutlined()"
    [class.td-wb-avatar__container--small]="isSmall()">
  <td-wb-icon class="td-wb-avatar__icon"
              iconId="avatar--small"
              size="18"/>
</span>
}
@if (hasInitials()) {
  <span
    class="td-wb-avatar__container td-wb-avatar__container--initial"
    [style.--td-wb-avatar-size]="getSize()"
    [class.td-wb-avatar__container--outlined]="isOutlined()"
    [class.td-wb-avatar__container--solid]="!isOutlined() && !isLogo()"
    [class.td-wb-avatar__container--small]="isSmall()"
    [class.td-wb-avatar__container--logo]="isLogo()"
    [class.td-wb-avatar__container--extra-large]="isExtraLarge()"
    [class.td-wb-avatar__container--extra-small]="isExtraSmall()">
    <span [innerText]="initials()"></span>
</span>
}
